<template>
  <confirm-dialog ref="confirm" title="Shipment Report" :confirmCb="reportShipping" :width="60">
    <template v-slot:content>
      <div v-loading="loadingReports">
        <!-- <div class="common-hint-list">
          <span>Please check carefully before reporting!</span>
        </div> -->
        <div class="f-c f-c-hsb summary-list">
          <basic-form class="summary-report" v-for="(report, index) in reports" :key="index" :mode="LOSE"
            :title="`Report ${index + 1}`" :form-params="ReportBasicWrapUp(report)">
            <template v-slot:actions>
              <el-checkbox
                :value="selectedReports[index]"
                @input="val => $set(selectedReports, index, val)"
                :disabled="!report.customerOrderNo"
                class="include-checkbox"
              >
                Include in submit
              </el-checkbox>
            </template>
          </basic-form>
        </div>
      </div>
    </template>
    <template v-slot:footer-ops>
      <el-button size="small" type="primary" plain @click="selectAllReports">
        Select all
      </el-button>
      <el-button size="small" plain @click="unselectAllReports">
        Unselect all
      </el-button>
      <el-button size="small" type="primary" @click="submitAllReports">
        Submit all
      </el-button>
    </template>
  </confirm-dialog>
</template>
<script>
import { getProxyShippingReports, reportProxyOrderShipment } from '@/api/orderProxy'
import ConfirmDialog from '@/components/common/Confirm.vue'
import BasicForm from '@/components/common/BasicForm.vue'
import { FormModes } from '@/core/configs/types'
import { ReportBasicWrapUp } from '@/core/models/shipment'
export default {
  name: 'BusinessOrderShippingReport',
  props: {
    shipmentNo: {
      type: String,
      Required: true
    }
  },
  components: {
    ConfirmDialog,
    BasicForm
  },
  data() {
    return {
      LOSE: FormModes.LOOSE,
      loadingReports: false,
      reports: [],
      selectedReports: []
    }
  },
  computed: {
    reportInfo() {
      return ReportBasicWrapUp(this.shipment)
    }
  },
  methods: {
    ReportBasicWrapUp,
    open() {
      this.getReports()
      this.$refs.confirm.open()
    },
    selectAllReports() {
      this.reports.forEach((r, i) => {
        this.$set(this.selectedReports, i, !!r.customerOrderNo)
      })
    },
    unselectAllReports() {
      this.reports.forEach((_, i) => {
        this.$set(this.selectedReports, i, false)
      })
    },
    submitAllReports() {
      this.selectAllReports()
      this.$nextTick(() => this.$refs.confirm.confimClick())
    },
    reportShipping(done, error) {
      const selectedReports = this.selectedReports
        .map((sel, i) => (sel ? i : -1))
        .filter(i => i >= 0)
        .map(i => this.reports[i])
      if (!selectedReports.length) {
        error('Please select at least one report to include.')
        return
      }
      this.loadingReports = true
      reportProxyOrderShipment(this.shipmentNo, selectedReports)
        .then(res => {
          done()
          this.$message.success('Report shipping Success')
        })
        .catch(err => {
          error('Report shipping Failed, ' + err)
        }).finally(() => {
          setTimeout(() => {
            this.loadingReports = false
          }, 500)
        })
    },
    getReports() {
      this.loadingReports = true
      getProxyShippingReports(this.shipmentNo).then(res => {
        this.$set(this, 'reports', res.reports)
        this.$set(this, 'selectedReports', (res.reports || []).map(r => !!r.customerOrderNo))
      }).finally(() => {
        setTimeout(() => {
          this.loadingReports = false
        }, 500)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.summary-report {
  margin: 0px;
  box-shadow: none;
  border: 1px solid #ebeef5;
  border-radius: 5px;
}
.include-checkbox {
  margin-right: 0;
}
</style>
